
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/summit/previous",
      function () {
        return require("private-next-pages/summit/previous/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/summit/previous"])
      });
    }
  